export interface NavClickPayload { rubrique: string; lien: string; emplacement: string }

/** Emplacements de la spec (section 7) : menu, menu_mobile, barre_mobile, pied, accueil, et_aussi, fil_ariane. */
export function navClickPayload(link: Element): NavClickPayload | null {
  const zone = link.closest<HTMLElement>("[data-nav-emplacement]");
  const href = link.getAttribute("href");
  if (!zone || !href) return null;
  const rubrique = link.getAttribute("data-nav-rubrique")
    ?? link.closest("[data-nav-rubrique]")?.getAttribute("data-nav-rubrique")
    ?? "aucune";
  return { rubrique, lien: href.split(/[?#]/)[0], emplacement: zone.dataset.navEmplacement ?? "inconnu" };
}

function sendWithKenoTrack(p: NavClickPayload): void {
  try { window.kenoTrack?.("nav_clicked", { ...p }); } catch { /* jamais bloquant */ }
}

/** Écouteur délégué en phase de capture : passe avant la fenêtre « compte requis ». */
export function initNavTracking(doc: Document, send: (p: NavClickPayload) => void = sendWithKenoTrack): () => void {
  const onClick = (e: Event) => {
    const link = (e.target as Element | null)?.closest?.("a[href]");
    if (!link) return;
    const payload = navClickPayload(link);
    if (payload) send(payload);
  };
  doc.addEventListener("click", onClick, true);
  return () => doc.removeEventListener("click", onClick, true);
}
